import { render, staticRenderFns } from "./ImageSettings.vue?vue&type=template&id=5712eae3&scoped=true"
import script from "./ImageSettings.vue?vue&type=script&lang=ts"
export * from "./ImageSettings.vue?vue&type=script&lang=ts"
import style0 from "./ImageSettings.vue?vue&type=style&index=0&id=5712eae3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712eae3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5712eae3')) {
      api.createRecord('5712eae3', component.options)
    } else {
      api.reload('5712eae3', component.options)
    }
    module.hot.accept("./ImageSettings.vue?vue&type=template&id=5712eae3&scoped=true", function () {
      api.rerender('5712eae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ImageSettings.vue"
export default component.exports